import { getAxiosConfigUserToken } from 'app/utils/appHelpers';
import axios from 'axios';
import config from '../../config';

export const postSaveAnnouncementApi = async (object) => {
   const url = `${config.apiUrl}/v1/announcements`;
   return await axios.post(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
};

export const putUpdateAnnouncementApi = async (object) => {
   const url = `${config.apiUrl}/v1/announcements/${object.id}`;
   return await axios.put(url, object, getAxiosConfigUserToken())
      .then(response => response.data);
};
